// Penalty Takers — types + shaping (Phase 3).
//
// Per-team penalty record: each taker's scored/taken and the success %. Pure and
// framework-free; the data is read from the legacy `window.BentoData` via the
// app-web accessor, and this only shapes it. The React component and the legacy
// renderer must produce identical rows; the visual A/B guards that.

/** One penalty taker as stored in the legacy data. */
export interface PenaltyTaker {
  name: string;
  taken: number;
  scored: number;
}

/** Penalty takers keyed by full team name. */
export type PenaltyTakersData = Record<string, PenaltyTaker[]>;

/** A display row: the taker plus the conversion % (0–100). */
export interface PenaltyTakerRow {
  name: string;
  scored: number;
  taken: number;
  /** Conversion %, rounded — `round(scored / taken * 100)`, matching legacy. */
  pct: number;
}

/** Shape takers into display rows (adds the rounded conversion %). */
export function shapePenaltyTakers(
  players: readonly PenaltyTaker[]
): PenaltyTakerRow[] {
  return players.map((p) => ({
    name: p.name,
    scored: p.scored,
    taken: p.taken,
    pct: Math.round((p.scored / p.taken) * 100),
  }));
}
